import { db } from "@/firebase"
import firebase from 'firebase'
import { parDiasComparar } from '@/utils/dias.utils.js'
import moment from 'moment'
export default {
  getAlertas({ commit }) {
    const dias = parDiasComparar();
    db.collection('alertas')
      .where('fecha', '>=', dias[0])
      .where('fecha', '<=', dias[1])
      .onSnapshot((snapDoc) => {
        var res = []
        snapDoc.forEach(e => {
          let d = e.data();
          d.id = e.id;
          res.push(d);
        });

        commit('setAlertas', res);
        return
      })
  },
  marcarSolucionado({ rootState }, item) {
    console.log(item);
    return db.collection('alertas').doc(item.id).get()
      .then((r) => {
        if (r.exists) {
          let usuario = (rootState.auth.user.email) ? rootState.auth.user.email : rootState.auth.user.uid;
          return r.ref.set({
            estado: 'solucionado',
            prioridad: 3,
            historial: firebase.firestore.FieldValue.arrayUnion(
              {
                fecha: moment().unix(),
                usuario: usuario,
                mensaje: 'Marcado solucionado por ' + usuario
              }
            )
          }, { merge: true })
        } else {
          return Promise.reject('alerta/not-exists')
        }
      })
  }
}